var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { useEffect, useRef, useState } from 'react';
import { FactoryContent } from '../../../../factory';
import useDesign from '../../../../hooks/useDesign';
import { TooltipPopoverWrapper } from '../styled';
import { getElementCoords } from '../utils';
export var TooltipPopover = function (_a) {
    var _b, _c;
    var design = _a.design, children = _a.children, el = _a.el, error = _a.error, props = __rest(_a, ["design", "children", "el", "error"]);
    var _d = useDesign(design), config = _d.config, schema = _d.schema;
    var _e = useState(false), isOn = _e[0], setOn = _e[1];
    var _f = props.config || {}, popoverContent = _f.content, popoverPosition = _f.position, translatedText = _f.translatedText;
    var _g = translatedText || {}, _extends = _g._extends, translatedTextConfig = __rest(_g, ["_extends"]);
    var _h = (translatedTextConfig || {}).values, values = _h === void 0 ? {} : _h;
    var combinedValues = __assign(__assign({}, values), (props.values || {}));
    translatedTextConfig.values = combinedValues;
    var popoverRef = useRef(null);
    var popoverContentByProps = translatedText || _extends
        ? [['TranslatedText', _extends, translatedTextConfig]]
        : popoverContent;
    var _j = useState(getElementCoords(el, popoverRef.current)), coords = _j[0], setCoords = _j[1];
    var position = popoverPosition || config.position || props.position;
    var merged = __assign(__assign({}, config), (popoverContentByProps && { content: popoverContentByProps || popoverContent }));
    useEffect(function () {
        setCoords(getElementCoords(el, popoverRef.current, position));
    }, [el, setCoords, position, (_b = popoverRef.current) === null || _b === void 0 ? void 0 : _b.clientHeight, (_c = popoverRef.current) === null || _c === void 0 ? void 0 : _c.clientWidth]);
    useEffect(function () {
        setOn(true);
    }, []);
    return (_jsx(TooltipPopoverWrapper, __assign({ ref: popoverRef, schema: schema, style: __assign({}, coords), isOn: isOn, error: error }, props, { children: _jsx(FactoryContent, { error: error, config: merged, values: combinedValues }) })));
};
